export const secondaryNavData = {
  title: 'Scroll down for',
  tabs: [
    {
      title: 'featured',
      url: '#featured',
      active: true,
    },
    {
      title: 'circular economy examples',
      url: '#circular-economy-examples',
      active: false,
    },
    {
      title: 'our mission',
      url: '#our-mission',
      active: false,
    },
  ],
};
